// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export const COOLING_SYSTEM_COMPONENT_ID = 20;
export const CT_NAEOTOM_ALPHA_MATERIAL_NUMBERS = [11330003, 10191100, 11549431];
export enum CoolingSystemType {
  UNKNOWN = -1, // New Type Found
  NONE = 0, // No Data
  AIR = 1, // Air type has only Air
  WATER = 2, // Water Type has both Air, Water
}
